import { createAction } from 'redux-actions';
import types from '../types';

export const openMenu = createAction(types.MENU_OPEN);
export const closeMenu = createAction(types.MENU_CLOSE);
export const selectMenuItem = createAction(types.MENU_ITEM_SELECT);
export const toggleDragAndDrop = createAction(types.TOGGLE_DRAG_AND_DROP);
export const searchChanged = createAction(types.SEARCH_CHANGED);
